import { render } from "./TheMusicbar.vue?vue&type=template&id=11d801c6&scoped=true"
import script from "./TheMusicbar.vue?vue&type=script&lang=js"
export * from "./TheMusicbar.vue?vue&type=script&lang=js"

import "./TheMusicbar.vue?vue&type=style&index=0&id=11d801c6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d801c6"]])

export default __exports__